<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-flex shrink style="text-align: right"
          ><v-btn
            @click="printPage()"
            dark
            style="width: 80px; background-color: black"
            ><v-icon>local_printshop</v-icon></v-btn
          ></v-flex
        >
        <!-- Nevigater -->
        <v-layout mb-12 v-if="$route.query.name === 'verify-rf'">
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>ตรวจสอบแบบฟอร์ม RF</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span
              >แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา (RF
              04_1_2563)</span
            >
          </v-flex>
        </v-layout>
        <v-layout v-else mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout>
              <v-flex>
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: left; font-size: 28px; color: white"
                  >
                    <div style="font-weight: bold">
                      แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา
                      (RF 04_1_2563)
                    </div>
                    <div style="font-size: 18px">
                      Adverse Drug Reaction Report (เฉพาะ Serious หรือ
                      Unexpected)
                    </div>
                  </v-flex>
                  <v-flex
                    ml-8
                    pt-8
                    pr-8
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 13px;
                      color: white;
                    "
                  >
                    <span>RF 04_1_2563</span>
                  </v-flex>
                </v-layout>

                <!-- blog 1 -->
                <v-card
                  class="py-12"
                  style="padding-right: 80px; padding-left: 80px"
                >
                  <v-layout>
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>1. รหัสโครงการ</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <textfield-form
                            :model="form.research_pass"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>2. ชื่อโครงการวิจัย</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <textarea-form
                            :model="form.researchName"
                            readonly
                          ></textarea-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>3. ชื่อผู้วิจัยหลัก</span>
                        </v-flex>
                      </v-layout>
                      <v-layout px-4>
                        <v-flex style="color: #3e7662">
                          <textfield-form
                            label="ชื่อ"
                            :model="form.fname"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-flex ml-3 style="color: #3e7662">
                          <textfield-form
                            label="นามสกุล"
                            :model="form.lname"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>4. สังกัด / เบอร์โทรศัพท์ติดต่อ</span>
                        </v-flex>
                      </v-layout>
                      <v-layout pb-3>
                        <v-flex>
                          <textfield-form
                            :model="form.party"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 5 -->
                      <v-layout pb-3 justify-space-between>
                        <v-flex
                          mr-6
                          shrink
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>5. อาสาสมัคร</span>
                        </v-flex>
                        <v-flex>
                          <v-radio-group v-model="form.volunteer_checkbox">
                            <v-layout my-3 align-center>
                              <v-flex>
                                <v-radio
                                  readonly
                                  color="#3E7662"
                                  label="ในสถาบัน"
                                  value="1"
                                ></v-radio>
                              </v-flex>
                            </v-layout>
                            <v-layout my-3 align-center>
                              <v-flex shrink>
                                <v-radio
                                  readonly
                                  color="#3E7662"
                                  label="ประเทศไทย"
                                  value="2"
                                ></v-radio>
                              </v-flex>
                              <v-flex pl-4>
                                <textfield-form
                                  readonly
                                  :background-color="
                                    !form.volunteer_checkbox
                                      ? 'gray'
                                      : '#FBF6F3'
                                  "
                                  :disabled="form.volunteer_checkbox !== '2'"
                                  hide-detail
                                  :model="form.volunteer"
                                  @update-data="updateData('volunteer', $event)"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                            <v-layout my-3 align-center>
                              <v-flex shrink>
                                <v-radio
                                  readonly
                                  color="#3E7662"
                                  label="ต่างประเทศ"
                                  value="3"
                                ></v-radio>
                              </v-flex>
                              <v-flex pl-4>
                                <textfield-form
                                  readonly
                                  :background-color="
                                    !form.volunteer_checkbox
                                      ? 'gray'
                                      : '#FBF6F3'
                                  "
                                  :disabled="form.volunteer_checkbox !== '3'"
                                  hide-detail
                                  :model="form.volunteerForeign"
                                  @update-data="
                                    updateData('volunteerForeign', $event)
                                  "
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- row 6 -->
                      <v-layout pt-6 justify-space-between>
                        <v-flex
                          mr-10
                          shrink
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>6. ชื่อย่อ/รหัสอาสาสมัคร Patient Initial</span>
                        </v-flex>
                        <v-flex d-flex align-center>
                          <textfield-form
                            hide-detail
                            :model="form.patient_initial"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 7 -->
                      <v-layout pt-10>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>7. วันเกิด</span>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <textfield-form
                            hide-detail
                            :model="birthDate"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-flex justify-end xs2 d-flex align-center>
                          <span style="text-align: left; font-weight: bold"
                            >8. อายุ</span
                          >
                        </v-flex>
                        <v-flex xs2 mx-4 d-flex align-center>
                          <textfield-form
                            hide-detail
                            :model="form.year"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <span style="text-align: left; font-weight: bold"
                            >ปี</span
                          >
                        </v-flex>
                      </v-layout>
                      <!-- row 8 -->
                      <v-layout mt-4>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>9. เพศ</span>
                        </v-flex>
                        <v-flex
                          pt-6
                          d-flex
                          align-center
                          style="text-align: left"
                        >
                          <v-radio-group readonly v-model="form.sex" row>
                            <v-radio
                              color="#3E7662"
                              style="padding-right: 40px"
                              label="ชาย"
                              value="0"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="หญิง"
                              value="1"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- row 9 -->
                      <v-layout mt-4>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>10.1 วันที่เกิดอาการ</span>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <textfield-form
                            hide-detail
                            :model="dateSymptom"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <v-layout mt-4>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>10.2 วันที่ผู้วิจัยทราบ</span>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <textfield-form
                            hide-detail
                            :model="dateKnow"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 9 -->
                      <v-layout mb-3 mt-10>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span
                            >11.รายละเอียดเหตุการณ์ไม่พึงประสงค์
                            (รวมทั้งการตรวจทางห้องปฏิบัติการ)</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <textarea-form
                            hide-detail
                            :model="form.detail_events"
                            readonly
                            :rows="8"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- blog 2 -->
                <v-layout mt-12 style="background-color: #3e7662">
                  <v-flex
                    pl-6
                    my-5
                    ml-8
                    style="font-size: 18px; color: white; text-align: left"
                  >
                    <span>ข้อมูลยา (Suspect drugs information)</span>
                  </v-flex>
                </v-layout>
                <v-layout
                  py-12
                  style="
                    background-color: white;
                    padding-left: 60px;
                    padding-right: 70px;
                  "
                >
                  <v-flex>
                    <v-layout mb-3>
                      <v-flex
                        style="
                          text-align: left;
                          font-weight: bold;
                          text-align: left;
                        "
                      >
                        <span
                          >12.ยาที่ใช้ (Suspect drugs) ทั้ง Generic name และ
                          Trade name</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex style="text-align: left">
                        <textarea-form :model="form.suspect_drug" readonly />
                      </v-flex>
                    </v-layout>
                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>13.ขนาดยา (Daily doses)</span>
                      </v-flex>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>14.วิธีให้ยา (Route)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex style="text-align: left">
                        <textarea-form :model="form.daily_doses" readonly />
                      </v-flex>
                      <v-flex pl-10 style="text-align: left">
                        <textarea-form :model="form.route" readonly />
                      </v-flex>
                    </v-layout>
                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>15.ข้อบ่งชี้ของการให้ยา (Indications)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex style="text-align: left">
                        <textarea-form :model="form.indications" readonly />
                      </v-flex>
                    </v-layout>
                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >16.วันที่เริ่มให้ยา และระยะเวลาการให้ยา (Therapy date
                          and duration)</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex style="text-align: left">
                        <textarea-form
                          :model="form.TherapyDateAndDuration"
                          readonly
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Blog 3 -->
                <v-layout style="background-color: #3e7662">
                  <v-flex
                    pl-6
                    my-5
                    ml-8
                    style="font-size: 18px; color: white; text-align: left"
                  >
                    <span>ยาที่ให้ร่วม (Concomitant drugs and history)</span>
                  </v-flex>
                </v-layout>
                <v-layout
                  py-12
                  style="
                    background-color: white;
                    padding-left: 60px;
                    padding-right: 70px;
                  "
                >
                  <v-flex>
                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >17.ยาที่ให้ร่วม และวันที่ให้ยา
                          (ไม่รวมยาที่ใช้เพื่อรักษาอาการไม่พึงประสงค์จากยา)</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex style="text-align: left">
                        <textarea-form :model="form.date_medication" readonly />
                      </v-flex>
                    </v-layout>
                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >18.ประวัติอื่นที่อาจเกี่ยวข้อง เช่น การแพ้ยา
                          การตรวจทางห้องปฏิบัติการ การตั้งครรภ์</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex style="text-align: left">
                        <textarea-form :model="form.other_history" readonly />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Blog 4 -->
                <v-layout style="background-color: #3e7662">
                  <v-flex
                    pl-6
                    my-5
                    ml-8
                    style="font-size: 18px; color: white; text-align: left"
                  >
                    <span>ข้อมูลบริษัทผลิตยา (Manufacturer Information)</span>
                  </v-flex>
                </v-layout>
                <v-layout
                  py-12
                  style="
                    background-color: white;
                    padding-left: 60px;
                    padding-right: 70px;
                  "
                >
                  <v-flex>
                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>19.ชื่อ ที่อยู่ บริษัทยา</span>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex style="text-align: left">
                        <textarea-form
                          :model="form.pharmaceutical_company_address"
                          readonly
                        />
                      </v-flex>
                    </v-layout>

                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>20.รหัสยา</span>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex xs6 style="text-align: left">
                        <textfield-form
                          :model="form.pharmaceuticalCode"
                          readonly
                        />
                      </v-flex>
                    </v-layout>

                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>21. ชนิดของการรายงาน</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group readonly v-model="form.reportType" row>
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ครั้งแรก Initial report"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="เพื่อติดตาม Follow-up report"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-6 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>22. เหตุการณ์ที่เกิดขึ้น</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group readonly v-model="form.incident">
                          <v-radio
                            color="#3E7662"
                            label="คาดว่าอาจจะเกิด"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่คาดว่าจะเกิด Unexpected (ไม่ได้ระบุในโครงร่างการวิจัยหรือ Investigator brochure)"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="Nature"
                            value="3"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="Severity"
                            value="4"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="Frequency"
                            value="5"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-6 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >23. ความสัมพันธ์กับยาที่ใช้ในการวิจัย (Relation to
                          the study)</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group readonly v-model="form.relationStudy">
                          <v-radio
                            color="#3E7662"
                            label="ไม่เกี่ยวข้อง (Not related)"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="อาจเกี่ยวข้อง (Possibly related)"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="น่าจะเกี่ยวข้อง (Probably related)"
                            value="3"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="เกี่ยวข้องแน่นอน (Definitely related)"
                            value="4"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่รู้ (Unknown)"
                            value="5"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-6 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>24. ลงนามผู้วิจัย</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <TextfieldForm
                          style="color: #3e7662"
                          label="ชื่อ"
                          :model="form.signedResearcherFname"
                          readonly
                        />
                      </v-flex>
                      <v-flex ml-12>
                        <TextfieldForm
                          style="color: #3e7662"
                          label="bb"
                          :model="form.signedResearcherLname"
                          readonly
                        />
                      </v-flex>
                    </v-layout>

                    <v-layout mt-8>
                      <v-flex
                        shrink
                        mr-10
                        d-flex
                        align-center
                        style="text-align: left; font-weight: bold"
                      >
                        <span>25. วันที่รายงาน</span>
                      </v-flex>
                      <v-flex xs2 d-flex align-center>
                        <TextfieldForm
                          hide-detail
                          style="color: #3e7662"
                          :model="reportDate"
                          readonly
                        />
                      </v-flex>
                    </v-layout>

                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>ก. ตรวจสอบความร้ายแรง (severity)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group readonly v-model="form.severity">
                          <v-radio
                            color="#3E7662"
                            label="1. ตาย (Death)"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. รุนแรงและอาจทำให้เสียชีวิต (Life threatening)"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="3. ต้องรักษาในโรงพยาบาล (Hospitalization / prolonged hospitalization)"
                            value="3"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="4. พิการหรือทุพลภาพ (Persistent or significant disability / incapacity)"
                            value="4"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="5. ทารกพิการแต่กำเนิด (Congenital anomaly / birth defect)"
                            value="5"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="6. ไม่ร้ายแรง"
                            value="6"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>ข. อาการหายไปหลังหยุดยาหรือไม่</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group
                          readonly
                          v-model="form.symptomDisappear"
                          row
                        >
                          <v-radio
                            color="#3E7662"
                            label="หายไป"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่หาย"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ตอบไม่ได้"
                            value="3"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >ค. อาการเกิดขึ้นใหม่ เมื่อกลับให้ยาอีกหรือไม่</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group
                          readonly
                          v-model="form.hasRecurrentAfterStop"
                          row
                        >
                          <v-radio
                            color="#3E7662"
                            label="เกิดซ้ำ"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่เกิดอีก"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ตอบไม่ได้"
                            value="3"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>ง. การดำเนินเหตุการณ์ (Progression)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group readonly v-model="form.progression" row>
                          <v-radio
                            color="#3E7662"
                            label="1. แก้ไขแล้ว (Resolved)"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. ยังคงมีปัญหา (Ongoing)"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="3. ไม่เกี่ยวข้อง (N/a)"
                            value="3"
                          >
                          </v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>จ. การเปลี่ยนแปลงโครงร่างการวิจัย</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group
                          readonly
                          v-model="form.changesResearchProposal"
                        >
                          <v-radio
                            color="#3E7662"
                            label="1. ไม่เปลี่ยน"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 12_2563 ให้คณะอนุกรรมการฯ)"
                            value="2"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >ฉ. การเปลี่ยนแปลงเอกสารชี้แจงข้อมูลอาสาสมัคร</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group
                          readonly
                          v-model="form.changeClarificationDocument"
                        >
                          <v-radio
                            color="#3E7662"
                            label="1. ไม่เปลี่ยน"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 12_2563 ให้คณะอนุกรรมการฯ)"
                            value="2"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout mt-12 mb-8>
                      <v-flex
                        style="
                          color: #cc3d45;
                          font-size: 14px;
                          text-align: left;
                        "
                      >
                        <span>
                          *ถ้าเป็นเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง(ก 1-5)
                          ผู้วิจัยควรส่งรายงานแก่คณะอนุกรรมการพิจารณาโครงการวิจัย
                          พบ. ภายใน 7 วัน หลังทราบเหตุการณ์
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Blog 5 -->
                <v-layout mt-12 style="background-color: #3e7662">
                  <v-flex
                    pl-6
                    my-5
                    ml-8
                    style="font-size: 18px; color: white; text-align: left"
                  >
                    <span>Naranjo’s algorithm</span>
                  </v-flex>
                </v-layout>
                <v-layout
                  py-12
                  style="
                    background-color: white;
                    padding-left: 60px;
                    padding-right: 70px;
                  "
                >
                  <v-flex>
                    <v-layout mb-3>
                      <v-flex xs6 style="text-align: left; font-weight: bold">
                        <span>ชื่อยา</span>
                      </v-flex>
                      <v-flex xs6 style="text-align: left; font-weight: bold">
                        <span>เลขที่แบบรายงาน</span>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex pr-12 xs6 style="text-align: left">
                        <textfield-form :model="form.drugName" readonly />
                      </v-flex>
                      <v-flex xs6 style="text-align: left">
                        <textfield-form :model="form.reportNumber" readonly />
                      </v-flex>
                    </v-layout>

                    <v-layout mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>อาการไม่พึ่งประสงค์</span>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-4>
                      <v-flex style="text-align: left">
                        <textarea-form
                          :rows="7"
                          :model="form.symptom"
                          readonly
                        />
                      </v-flex>
                    </v-layout>

                    <v-card>
                      <!-- header -->
                      <v-layout
                        py-3
                        style="background-color: #3e7662; color: white"
                      >
                        <v-flex
                          xs8
                          pr-12
                          pl-12
                          style="text-align: left; font-size: 18px"
                          >คำถาม</v-flex
                        >
                        <v-flex xs1 pr-8>ใช่</v-flex>
                        <v-flex xs1 pr-8>ไม่ใช่</v-flex>
                        <v-flex xs1 pr-8>ไม่ทราบ</v-flex>
                        <v-flex xs1 pr-4>คะแนน</v-flex>
                      </v-layout>
                      <!-- row detail -->
                      <v-layout pl-6 py-3>
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >1.
                          เคยมีสรุปหรือรายงานการเกิดปฏิกิริยานี้มาแล้วหรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point1"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3 style="background-color: #fbf6f3">
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >2.
                          อาการไม่พึงประสงค์นี้เกิดขึ้นภายหลังจากได้รับยาที่คิดว่าเป็นสาเหตุหรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point2"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3>
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >3. อาการไม่พึงประสงค์นี้ดีขึ้นเมื่อหยุดยาดังกล่าว
                          หรือเมื่อให้ยาต้านที่จำเพาะเจาะจง (specific
                          antagonist) หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point3"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3 style="background-color: #fbf6f3">
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >4.
                          อาการไม่พึงประสงค์ดังกล่าวเกิดขึ้นเมื่อเริ่มให้ยาใหม่หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point4"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3>
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >5. ปฏิกิริยาที่เกิดขึ้นสามารถเกิดจากสาเหตุอื่น
                          (นอกเหนือจากยา) ของอาสาสมัครได้หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point5"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3 style="background-color: #fbf6f3">
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >6. ปฏิกิริยาดังกล่าวเกิดขึ้นอีก เมื่อให้ยาหลอก
                          หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point6"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3>
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >7. ตรวจวัดปริมาณยาได้ในเลือด(หรือของเหลวอื่น)
                          ในปริมาณความเข้มข้นที่เป็นพิษ หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point7"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3 style="background-color: #fbf6f3">
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >8. ปฏิกิริยารุนแรงที่เกิดขึ้นเมื่อเพิ่มขนาดยา
                          หรือลดความรุนแรงลงเมื่อลดขนาดยา หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point8"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3>
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >9.
                          อาสาสมัครเคยมีประวัติเกิดปฏิกิริยาเหมือนหรือคล้ายคลึงกันนี้มาก่อน
                          เมื่อได้รับยาชนิดนี้ หรือ
                          ยาในกลุ่มเดียวกันในครั้งก่อนๆ หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point9"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout pl-6 py-3 style="background-color: #fbf6f3">
                        <v-flex xs8 pt-2 pr-12 style="text-align: left"
                          >10. อาการไม่พึงประสงค์นี้
                          ได้รับการยืนยันโดยหลักฐานที่เป็นรูปธรรม (objective
                          evidence) หรือไม่</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >+1</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pt-2 pr-8 style="font-weight: bold"
                          >0</v-flex
                        >
                        <v-flex xs1 pr-3 style="font-weight: bold">
                          <textfield-form
                            hide-detail
                            :model="form.point10"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <!-- footer -->
                      <v-layout
                        py-3
                        style="background-color: #3e7662; color: white"
                      >
                        <v-flex
                          class="font-weight-bold font-weight-medium d-flex align-center justify-center"
                          >รวม</v-flex
                        >
                        <v-flex
                          xs1
                          pr-3
                          class="justify-end"
                          style="font-weight: bold"
                        >
                          <textfield-form
                            hide-detail
                            :model="form.sumPoint"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                    </v-card>

                    <v-layout pl-12 mt-8>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>ระดับคะแนน</span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12 pt-2>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>คะแนนมากกว่าหรือเท่ากับ 9</span>
                      </v-flex>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>Definite (certain) ใช่แน่</span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12 pt-2>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>คะแนนเท่ากับ 5 – 3</span>
                      </v-flex>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>Probable ใช่</span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12 pt-2>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>คะแนนเท่ากับ1 – 4</span>
                      </v-flex>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>Possible อาจจะใช่</span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12 pt-2>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>คะแนนน้อยกว่าหรือเท่ากับ 0</span>
                      </v-flex>
                      <v-flex xs3 style="text-align: left; font-size: 14px">
                        <span>Doubtful (unlikely) น่าสงสัย (ไม่น่าใช่)</span>
                      </v-flex>
                    </v-layout>

                    <v-layout class="my-12">
                      <v-flex>
                        <v-layout class="mb-8">
                          <v-flex>
                            <!-- <v-layout mb-3>
                              <v-flex shrink pr-4 style="text-align: left">
                                <span style="font-weight: bold; font-size: 16px"
                                  >SASAR Line Listing :
                                </span>
                              </v-flex>
                              <v-flex shrink>
                                <span
                                  class="text-start linkPDF"
                                  style="font-size: 16px; color: #cc3d45"
                                  @click="open('sasarLineListing')"
                                >
                                  {{ sasarLineListing }}
                                </span>
                              </v-flex>
                              <v-spacer></v-spacer>
                            </v-layout> -->
                            <!-- <v-layout mb-3>
                              <v-flex shrink pr-4 style="text-align: left">
                                <span style="font-weight: bold; font-size: 16px"
                                  >DSMB Letter :
                                </span>
                              </v-flex>
                              <v-flex shrink>
                                <span
                                  class="text-start linkPDF"
                                  style="font-size: 16px; color: #cc3d45"
                                  @click="open('dsmbLetter')"
                                >
                                  {{ dsmbLetter }}
                                </span>
                              </v-flex>
                              <v-spacer></v-spacer>
                            </v-layout> -->
                            <v-layout>
                              <v-flex shrink pr-4 style="text-align: left">
                                <span style="font-weight: bold; font-size: 16px"
                                  >หนังสือของหน่วยงาน :
                                </span>
                              </v-flex>
                              <v-flex shrink>
                                <span
                                  class="text-start linkPDF"
                                  style="font-size: 16px; color: #cc3d45"
                                  @click="open('agencyBook')"
                                >
                                  {{ agencyBook }}
                                </span>
                              </v-flex>
                              <v-spacer></v-spacer>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >เลขหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  :model="form.bookNumber"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mx-4 font-weight-bold"
                                shrink
                                >วันที่หนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  readonly
                                  :model="form.bookDate"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6 mt-5>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >หน่วยงานที่ออกหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  :model="form.instituteBook"
                                  @update-data="
                                    updateData('instituteBook', $event)
                                  "
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <div v-for="(input, k) in form.fileOther" :key="'d' + k" class="my-5">
                      <v-layout>
                        <v-flex>
                          <v-layout>
                            <v-flex
                              shrink
                              mr-4
                              pt-2
                              style="text-align: right;font-weight: bold;"
                            >
                              <span>ชื่อไฟล์</span>
                            </v-flex>
                            <v-flex xs2>
                              <textfield-form
                                hide-detail
                                :model="input.title"
                              ></textfield-form>
                            </v-flex>
                            <v-flex v-if="input.filePath"
                              ><a
                                :href="input.filePath"
                                target="_blank"
                                style="color: #3e7662;text-align: center"
                                class="link-hover"
                              >
                                <p>ไฟล์ที่อัพโหลด: {{ input.file }}</p>
                              </a>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout> </v-layout>
                    </div>

                    <v-layout pt-10>
                      <v-spacer></v-spacer>
                      <v-flex
                        xs6
                        style="font-weight: bold"
                        class="text-field-center"
                      >
                        <textfield-form-append
                          label="ลงชื่อผู้ประเมิน"
                          icon="edit"
                          :model="form.signature"
                          readonly
                        />
                      </v-flex>
                    </v-layout>

                    <v-layout mt-2>
                      <v-spacer></v-spacer>
                      <v-flex
                        xs6
                        pt-2
                        mr-4
                        shrink
                        style="
                          font-weight: bold;
                          text-align: right;
                          margin-left: -50px;
                        "
                      >
                        <span>วันที่</span>
                      </v-flex>
                      <v-flex xs3 style="font-weight: bold">
                        <TextfieldForm hide-detail :model="date" readonly />
                      </v-flex>
                      <v-spacer></v-spacer>
                    </v-layout>
                    <v-layout style="margin-top: 30px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>Note</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex style="padding-left: 32px; padding-right: 32px">
                        <textarea-form
                          @update-data="updateData('noteDetail', $event)"
                          :model="form.noteDetail"
                          :rows="5"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: -35px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>การตรวจสอบ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-left: 32px; margin-top: -15px">
                      <span style="font-weight: bold; padding-top: 19px"
                        >วันที่ผู้วิจัยรายงาน</span
                      >
                      <v-col cols="2" class="text-end text-field-center">
                        <DateInputForm
                          :model="researcherReportDate"
                          @update-data="
                            updateData('researcherReportDate', $event)
                          "
                          style="font-weight: bold"
                        >
                        </DateInputForm>
                      </v-col>
                    </v-layout>

                    <v-layout px-12 mb-8 pt-10>
                      <v-flex
                        xs11
                        style="
                          text-align: left;
                          font-size: 14px;
                          color: #3e7662;
                        "
                      >
                        <span>
                          อ้างอิง และ ปรับปรุงจากวารสารวิชาการสาธารณสุข 2559
                          ปีที่ 25 ฉบับที่ 4หน้า 673-682 และ Naranjo CA, Busto
                          U, Sellers EM, et al. (1981). “A method for estimating
                          the probability of adverse drug reactions”. Clin.
                          Pharmacol. Ther. 30(2):239-45.
                        </span>
                      </v-flex>
                    </v-layout>

                    <v-layout pt-12 justify-space-between="">
                      <v-flex d-flex justify-start>
                        <span
                          >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span
                        >
                      </v-flex>
                      <v-flex d-flex justify-end>
                        <span>หน้า 1 จาก 1 หน้า</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: left">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="$router.go(-1)"
                          >ย้อนกลับ</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex mb-12 style="text-align: right">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          v-if="status == 'รอดำเนินการ'"
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="saveEdit()"
                          ><v-icon>add</v-icon>บันทึกเพื่อแก้ไข</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../../components/input/TextfieldForm";
import TextareaForm from "../../../components/input/TextareaForm";
import DateInputForm from "../../../components/input/DateInputForm";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";
import Swal from "sweetalert2";


export default {
  name: "FormRF06",
  components: {
    TextfieldFormAppend,
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      fileOther: [],
      noteDetail: "",
      researcherReportDate: "",
      research_pass: "",
      researchName: "",
      fname: "",
      lname: "",
      party: "",
      volunteer_checkbox: false,
      volunteer: "",
      volunteerForeign: "",
      patient_initial: "",
      birthDate: "",
      year: "",
      sex: "",
      dateSymptom: "",
      detail_events: "",
      suspect_drug: "",
      daily_doses: "",
      route: "",
      indications: "",
      TherapyDateAndDuration: "",
      date_medication: "",
      other_history: "",
      pharmaceutical_company_address: "",
      pharmaceuticalCode: "",
      reportType: "",
      incident: "",
      relationStudy: "",
      signedResearcherFname: "",
      signedResearcherLname: "",
      reportDate: "",
      severity: "",
      symptomDisappear: "",
      hasRecurrentAfterStop: "",
      progression: "",
      changesResearchProposal: "",
      changeClarificationDocument: "",
      drugName: "",
      reportNumber: "",
      symptom: "",
      point1: "",
      point2: "",
      point3: "",
      point4: "",
      point5: "",
      point6: "",
      point7: "",
      point8: "",
      point9: "",
      point10: "",
      sumYes: "",
      sumNo: "",
      sumUnknown: "",
      sumPoint: "",
      agencyBook: "",
      bookNumber: "",
      bookDate: "",
      signature: "",
      date: "",
      instituteBook: "",
    },
    status: "",
    researcherReportDate: "",
    sasarLineListing: "",
    sasarLineListingPath: "",
    dsmbLetter: "",
    dsmbLetterPath: "",
    agencyBookPath: "",
    agencyBook: "",
    birthDate: "",
    date: "",
    dateSymptom: "",
    dateKnow: "",
    reportDate: "",
    userID: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    // if (this.user.currentRole !== 3) {
    //     this.$router.go(-1);
    // }
    this.getRF04_1();
  },
  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function(element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function(element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function(element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function(element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function(dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function(element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document.querySelectorAll(".v-icon").forEach(function(element) {
            element.style.display = "unset";
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function(error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function() {
            await document
              .querySelectorAll("button")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    saveEdit() {
      Swal.fire({
        title: "คุณต้องการบันทึกเพื่อแก้ไขหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึกเพื่อแก้ไข",
      }).then((result) => {
        if (result.value) {
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;

          this.isLoading = true;
          this.$store
            .dispatch("FormRF/saveEditRF04_1", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกเพื่อแก้ไขสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push("/verify-rf");
              });
              console.log("res", res);

              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    updateData(name, val) {
      if (name === "researcherReportDate") {
        this.researcherReportDate = this.changeDate(val.date);
        this.form.researcherReportDate = val.date;
      }
      if (name === "noteDetail") {
        this.form.noteDetail = val;
      }
    },
    changeDate(val) {
      if (val != null) {
        //change date start
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);
        sub_year = parseInt(sub_year) + 543;
        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return null;
      }
    },
    getRF04_1() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF04_1", this.$route.query.rfID)
        .then((res) => {
          this.form.fileOther = res.fileOther ?? [];
          this.form.instituteBook = res.instituteBook;
          this.status = res.status;
          this.form.noteDetail = res.noteDetail;
          this.form.researcherReportDate = res.noteDetailDate;
          this.researcherReportDate = this.changeDate(res.noteDetailDate);
          this.form.research_pass = res.research_pass;
          this.form.researchName = res.researchName;
          this.form.fname = res.fname;
          this.form.lname = res.lname;
          this.form.party = res.party;
          this.form.volunteer_checkbox = res.volunteer_checkbox
            ? res.volunteer_checkbox.toString()
            : "";
          this.form.volunteer = res.volunteer;
          this.form.volunteerForeign = res.volunteerForeign;
          this.form.patient_initial = res.patient_initial;
          this.form.birthDate = res.birthDate;
          this.birthDate = res.birthDate ? this.changeDate(res.birthDate) : "";
          this.form.year = res.year;
          this.form.sex = res.sex;
          this.form.dateSymptom = res.dateSymptom;
          this.dateSymptom = res.dateSymptom
            ? this.changeDate(res.dateSymptom)
            : "";
          this.form.dateKnow = res.dateKnow;
          this.dateKnow = res.dateKnow ? this.changeDate(res.dateKnow) : "";
          this.form.detail_events = res.detail_events;
          this.form.suspect_drug = res.suspect_drug;
          this.form.daily_doses = res.daily_doses;
          this.form.route = res.route;
          this.form.indications = res.indications;
          this.form.TherapyDateAndDuration = res.TherapyDateAndDuration;
          this.form.date_medication = res.date_medication;
          this.form.other_history = res.other_history;
          this.form.pharmaceutical_company_address =
            res.pharmaceutical_company_address;
          this.form.pharmaceuticalCode = res.pharmaceuticalCode;
          this.form.reportType = res.reportType;
          this.form.incident = res.incident;
          this.form.relationStudy = res.relationStudy;
          this.form.signedResearcherFname = res.signedResearcherFname;
          this.form.signedResearcherLname = res.signedResearcherLname;
          this.form.reportDate = res.reportDate;
          this.reportDate = res.reportDate
            ? this.changeDate(res.reportDate)
            : "";
          this.form.severity = res.severity;
          this.form.symptomDisappear = res.symptomDisappear;
          this.form.hasRecurrentAfterStop = res.hasRecurrentAfterStop
            ? res.hasRecurrentAfterStop.toString()
            : "";
          this.form.progression = res.progression;
          this.form.changesResearchProposal = res.changesResearchProposal;
          this.form.changeClarificationDocument =
            res.changeClarificationDocument;
          this.form.drugName = res.drugName;
          this.form.reportNumber = res.reportNumber;
          this.form.symptom = res.symptom;
          this.form.point1 = res.point1;
          this.form.point2 = res.point2;
          this.form.point3 = res.point3;
          this.form.point4 = res.point4;
          this.form.point5 = res.point5;
          this.form.point6 = res.point6;
          this.form.point7 = res.point7;
          this.form.point8 = res.point8;
          this.form.point9 = res.point9;
          this.form.point10 = res.point10;
          this.form.sumYes = res.sumYes;
          this.form.sumNo = res.sumNo;
          this.form.sumUnknown = res.sumUnknown;
          this.form.sumPoint = res.sumPoint;

          this.agencyBookPath = res.agencyBookPath;
          this.agencyBook = res.agencyBook;
          this.sasarLineListingPath = res.sasarLineListingPath;
          this.dsmbLetterPath = res.dsmbLetterPath;
          this.sasarLineListing = res.sasarLineListing;
          this.dsmbLetter = res.dsmbLetter;
          this.form.bookNumber = res.bookNumber;
          this.form.bookDate = !res.bookDate
            ? ""
            : res.bookDate
            ? this.changeDate(res.bookDate)
            : "";

          this.form.signature = res.signature;
          this.form.date = res.date;
          this.date = res.date ? this.changeDate(res.date) : "";
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    open(type) {
      switch (type) {
        case "sasarLineListing":
          window.open(this.sasarLineListingPath);
          break;
        case "dsmbLetter":
          window.open(this.dsmbLetterPath);
          break;
        case "agencyBook":
          window.open(this.agencyBookPath);
          break;
        default:
          return false;
      }
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
</style>
